import BasicContentFullWidthImage from './BasicContentFullWidthImage';

export { type BasicContentFullWidthImageProps } from './BasicContentFullWidthImage';
export default BasicContentFullWidthImage;
